import actions from "./actions";

export default {
  namespaced: true,
  state: () => ({
    categories: [],
    collections: [],
    collectionBooks: [],
    searchResults: [],
    highlighted_categories_library: [],
    library_categories: [],
    library: [],
    current_book: [],
    book: {},
    masterBooks: [],
    my_list: [],
  }),
  mutations: {
    setMasterBooks(state, books) {
      state.masterBooks = books;
    },
    setLibraryCategories(state, categories) {
      state.library_categories = categories;
    },
    pushHighlightedCategoriesLibrary(state, categorie) {
      state.highlighted_categories_library.push(categorie);
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setCollections(state, collections) {
      state.collections = collections;
    },
    setCollectionBooks(state, books) {
      if (books.length > 0) {
        state.collectionBooks.push({
          id: books[0].colletion.id,
          books: books,
        });
      }
    },
    setLibrary(state, library) {
      state.library = library;
    },
    setSearchResults(state, results) {
      state.searchResults = results;
    },
    setBook(state, book) {
      state.book = book;
    },
    setMyList(state, my_list) {
      state.my_list = my_list;
    },
  },
  actions,
};
